import React from 'react'
import Hero from './Hero';
import PartnerSection from './PartnerSection';
import MicrosoftSynectiksSection from './MicrosoftSynectiksSection';
import MicrosoftPartnerSection from './MicrosoftPartnerSection';
import M365ProsSection from './M365Pros';
import InnovationSection from './InnovationSection';

const Index = () => {
    return (
        <div>
            <Hero />
            <PartnerSection />
            <MicrosoftSynectiksSection />
            <MicrosoftPartnerSection />
            <M365ProsSection />
            <InnovationSection />
        </div>
    )
}

export default Index